<template>
  <div>
    <van-collapse v-model="activeNames">
      <van-collapse-item v-for="(item, index) in list" :key="index" :title="item.key" :name="index">
        <template #icon>
          <div class="leftIcon">
            Q{{index+1}}
          </div>
        </template>
        {{item.value}}
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import { getQueryTree} from "@/common/api.js";
export default {
  name: "commonProblem",
  components: {
  },
  data() {
    return {
      activeNames: [],
      list: []
    }
  },
  mounted() {
    this.getQueryTree()
  },
  methods: {
    async getQueryTree() {
      const res = await getQueryTree({code: 'VIOLATION_QA'})
      this.list = res
    }
  }
}
</script>
<style scoped lang="scss">
.leftIcon{
  font-size: 10px;
  color: #fff;
  background: url('../../assets/img/ticket/problem.png') 100%/100% no-repeat;
  margin-right: 0.1rem;
}
</style>